import * as Common from '@/agiles/common';

  export class WorkflowAction extends Common.ObjectBase{
        constructor(){
        super('WorkflowAction');
        this.binders.workflow = new Common.ModelBinder(Common.Workflow);
    } 
      public id: number=0;   
      public workflowId: number;
      public actionName: string;
      public stateIdFrom: number = null; //Workflow.actionsのindex+1を保持
      public stateIdTo: number = null;
      public workflow: Common.Workflow;
      public workflowCode: string='';
      public isTransit:boolean = false;
      public templateId:number = null;
      public isShowSendReport: boolean = false;
      public get sectionId(): number{
        //遷移元から取得する
        if (this.workflow && this.stateIdFrom != null) 
          return this.workflow.getState(this.stateIdFrom).sectionId;
        else 
          return this._sectionId;           
      }

      public set sectionId(value:number)
      {
          this._sectionId = value;
          //変更時にリセットする
          this.stateIdFrom = null;
          this.stateIdTo = null;
      }

      private _sectionId:number = null;

      public get sectionName():string{
        if (this.workflow) 
          return this.workflow.controller.sections.find(sec =>sec.value == this.sectionId).text;
        else 
          return ''; 
      }
      public getWorkflowStatusList():Common.BindItem[]{
        // if (this.workflow) return this.workflow.getList();
        // else return new Array<Common.BindItem>();
    
        //指定区間で自動判定ステータス以外を返す。
        var result = new  Array<Common.BindItem>();
        if (this.workflow){
          this.workflow.controller.systemStates
            .filter(state=> (state.type & Common.StateTypes.AutoStatus) != Common.StateTypes.AutoStatus)
            .filter(state=> state.sectionId == this.sectionId)
            .forEach(state => result.push(new Common.BindItem(state.workflowStateId, state.name)));
          this.workflow.userStates
            .filter(state=> state.sectionId == this.sectionId)          
            .forEach(state => result.push(new Common.BindItem(state.workflowStateId, state.name)));
        }

        return result;        
      }
      public getSectionList() {
        if (this.workflow) return this.workflow.controller.sections.slice(1);
        else return new Array();
      }

      
  }
  
export class WorkflowActionQuery extends Common.LoadQuery {
  constructor() {
    super('WorkflowActionQuery', WorkflowAction);
    this.sort = 'workflow';
  }
  public workflow: Common.Workflow;
}

export class InsertWorkflowActionQuery extends Common.Query {
    constructor(){
        super('InsertWorkflowActionQuery',null);
    }
    public insWorkflowAction: Common.WorkflowAction;
    public addWorkflowActionFromName: string;
    public addWorkflowStateName :string;
    public addWorkflowActionToName: string;
}

export class TranslationWorkflowActionQuery extends Common.Query {
    constructor(){
        super('TranslationWorkflowActionQuery',null);
    }
    public trCheckedItems: Array<WorkflowAction>;
    public trWorkflowStateFromId: number;
    public trWorkflowStateToId :number;
    public trWorkflowInsActionName: string;
}

//システムアクションを含む一覧を取得
export class UserWorkflowActionQuery extends Common.Query {
    constructor(){
        super('UserWorkflowActionQuery', new Common.ModelBinder(Common.WorkflowAction,true))
    }
}

